//============ fixf.core.services.enterprise.ReprotFill =============
import {
    DataPacket
} from '@/base/DataPacket';

export class ReprotFill extends DataPacket {
    constructor(opts= {}){
        super();
        this.CommitteeCode = opts.CommitteeCode || '';
        this.FillReportType = opts.FillReportType || null;
        this.KeyId = opts.KeyId || '';
        this.FormluateKeyId = opts.FormluateKeyId || '';
        this.OrgType = opts.OrgType || '';
        this.StreetName = opts.StreetName || '';
        this.Attachment = opts.Attachment || '';
        this.OrgCode = opts.OrgCode || '';
        this.Tel = opts.Tel || '';
        this.EaAreaName = opts.EaAreaName || '';
        this.CreateDate = opts.CreateDate || null;
        this.Area = opts.Area || '';
        this.Summary = opts.Summary || '';
        this.OrgName = opts.OrgName || '';
        this.IP = opts.IP || '';
        this.StreetCode = opts.StreetCode || '';
        this.CreatePerson = opts.CreatePerson || '';
        this.CommitStatus = opts.CommitStatus || '';
        this.IsUpLoadProject = opts.IsUpLoadProject || false;
        this.WorkId = opts.WorkId || '';
        this.TemplateName = opts.TemplateName || '';
        this.FillDetail = opts.FillDetail || '';
        this.IsUpLoadEmployee = opts.IsUpLoadEmployee || false;
        this.CommitteeName = opts.CommitteeName || '';
        this.EaAreaCode = opts.EaAreaCode || '';
        this.Status = opts.Status || '';
        this.UpdateRemake = opts.UpdateRemake || '';
    }
}